module.exports = __webpack_public_path__ + "static/media/lollipop-emoji.f3c87f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/lollipop-emoji.png
// module id = 35
// module chunks = 0